import { render } from "./OutsideBuildingView.vue?vue&type=template&id=3f5a5012&scoped=true"
import script from "./OutsideBuildingView.vue?vue&type=script&lang=js"
export * from "./OutsideBuildingView.vue?vue&type=script&lang=js"

import "./OutsideBuildingView.vue?vue&type=style&index=0&id=3f5a5012&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f5a5012"]])

export default __exports__